<div class="container py-4" style="max-width: 900px">
  <!-- Hero Banner -->
  <div class="booking-hero card border-0 mb-4">
    <div class="booking-hero__content">
      <div>
        <div class="booking-hero__eyebrow">Staff Onboarding</div>
        <h2 class="booking-hero__title mb-1">Add Practice Personnel</h2>
        <div class="booking-hero__meta">
          <span
            ><i class="bi bi-people me-1 text-primary"></i>Invite existing practitioners or create
            receptionist & nursing accounts</span
          >
        </div>
      </div>
    </div>
  </div>

  <!-- Capacity Warnings -->
  @if (doctorCapReached || receptionistCapReached) {
    <div class="alert alert-warning d-flex align-items-start mb-4" role="alert">
      <i class="bi bi-exclamation-triangle-fill me-2 mt-1"></i>
      <div>
        <strong>Practice Capacity Limits Reached</strong><br />
        @if (doctorCapReached) {
          <span class="d-block small mt-1"
            ><i class="bi bi-check-circle me-1"></i>Doctor limit (3/3) has been reached</span
          >
        }
        @if (receptionistCapReached) {
          <span class="d-block small mt-1"
            ><i class="bi bi-check-circle me-1"></i>Receptionist limit (5/5) has been reached</span
          >
        }
      </div>
    </div>
  }

  <div class="row g-4">
    <!-- Option 1: Invite Doctor -->
    <div class="col-md-6">
      <div
        class="card booking-card option-card h-100"
        [class.cursor-pointer]="!doctorCapReached"
        [class.opacity-50]="doctorCapReached"
        [class.pe-none]="doctorCapReached"
        (click)="goToInviteDoctor()"
      >
        <div
          class="card-body d-flex flex-column align-items-center justify-content-center text-center p-4 p-md-5 gap-3"
        >
          <div
            class="icon-circle"
            [class.bg-primary]="!doctorCapReached"
            [class.bg-secondary]="doctorCapReached"
            [class.text-white]="true"
          >
            <i class="bi bi-person-check-fill fs-3"></i>
          </div>
          <div>
            <h4 class="sub-title mb-1">Invite Doctor</h4>
            @if (doctorCapReached) {
              <p class="text-danger mb-0 small fw-semibold">
                <i class="bi bi-lock-fill me-1"></i>Doctor limit (3/3) reached
              </p>
              <p class="text-muted mb-0 small mt-2">
                Deactivate an existing doctor to invite a new one.
              </p>
            } @else {
              <p class="text-muted mb-0 small">
                Search for a registered doctor using their invitation code and link them to your
                practice.
              </p>
              <p class="text-success small mt-2">
                <i class="bi bi-check-circle me-1"></i>Available:
                {{ 3 - activeDoctorCount }} slot(s)
              </p>
            }
          </div>
          @if (!doctorCapReached) {
            <span class="btn btn-outline-primary btn-sm mt-2">
              Get Started <i class="bi bi-arrow-right ms-1"></i>
            </span>
          } @else {
            <span class="btn btn-outline-secondary btn-sm mt-2 disabled">
              Capacity Full <i class="bi bi-lock-fill ms-1"></i>
            </span>
          }
        </div>
      </div>
    </div>

    <!-- Option 2: Onboard Other Users -->
    <div class="col-md-6">
      <div
        class="card booking-card option-card h-100"
        [class.cursor-pointer]="!receptionistCapReached"
        [class.opacity-50]="receptionistCapReached"
        [class.pe-none]="receptionistCapReached"
        (click)="goToOnboardUsers()"
      >
        <div
          class="card-body d-flex flex-column align-items-center justify-content-center text-center p-4 p-md-5 gap-3"
        >
          <div
            class="icon-circle"
            [class.bg-primary]="!receptionistCapReached"
            [class.bg-secondary]="receptionistCapReached"
            [class.text-white]="true"
          >
            <i class="bi bi-person-plus-fill fs-3"></i>
          </div>
          <div>
            <h4 class="sub-title mb-1">Onboard Staff Members</h4>
            @if (receptionistCapReached) {
              <p class="text-danger mb-0 small fw-semibold">
                <i class="bi bi-lock-fill me-1"></i>Receptionist limit (5/5) reached
              </p>
              <p class="text-muted mb-0 small mt-2">
                Deactivate an existing receptionist to add a new one.
              </p>
            } @else {
              <p class="text-muted mb-0 small">
                Register and onboard new practice support staff such as receptionists and practice
                administrators.
              </p>
              <p class="text-success small mt-2">
                <i class="bi bi-check-circle me-1"></i>Available:
                {{ 5 - activeReceptionistCount }} slot(s)
              </p>
            }
          </div>
          @if (!receptionistCapReached) {
            <span class="btn btn-outline-primary btn-sm mt-2">
              Get Started <i class="bi bi-arrow-right ms-1"></i>
            </span>
          } @else {
            <span class="btn btn-outline-secondary btn-sm mt-2 disabled">
              Capacity Full <i class="bi bi-lock-fill ms-1"></i>
            </span>
          }
        </div>
      </div>
    </div>
  </div>
</div>
